__turbopack_context__.v({
  "bg-standard": "vVC_JG_bg-standard",
  "bg-subtle": "vVC_JG_bg-subtle",
  "image": "vVC_JG_image",
  "link": "vVC_JG_link",
  "placeholder": "vVC_JG_placeholder",
  "slide": "vVC_JG_slide",
  "text": "vVC_JG_text",
});
